module.exports = __webpack_public_path__ + "img/4_no.5b4643c6.svg";